<template>
  <div class="shareModulsBox">
    
    <!-- 二维码弹窗 -->
    <div class="shareModuls">
          <div class="rqCodeBox">
                <div class="close" @click="closeRqBox()">×</div>
                <div class="rqCodeImg">
                     <img :src="hmbfRqUrl" style="width: 100%;height: 100%;" alt="">
                </div>
                <div class="download" @click="download()">保存二维码</div>
          </div>
	</div>


  </div>
</template>
<script>
export default {
  data() {
    return {
        dialogVisible:false,
        hmbfRqUrl:'https://oss.tdin360.com/test/20221117/fd0abda563ea4111aab28e7b7914c2a7.jpg'
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 
    download(){
        console.log("==========>>>>");
        let url=this.hmbfRqUrl
        var alink = document.createElement("a");
        alink.href = url;
        alink.download = "pic"; //图片名
        alink.click();
    },

    // 
    closeRqBox(){
        console.log("组件关闭");
        this.$emit('closeRqBox')
    },
    // 
    openRq(){
       this.dialogVisible=true
    },
  },
}
</script>
<style scoped lang="scss">
 .shareModulsBox{
    cursor: pointer;
    .shareModuls{
	    position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
		    background: rgba(0,0,0,0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        cursor: pointer;
        .rqCodeBox{
            width: 20vw;
            height: 20vw;
            background: #fff;
            border-radius: 16px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .close{
                position: absolute;
                top: 0.2vw;
                right: 0.2vw;
                width: 3vw;
                height: 3vw;
                text-align: center;
                line-height: 3vw;
                font-size:2vw;
                cursor: pointer;
            }
            .rqCodeImg{
               width: 12vw;
               height: 12vw;
              //  border: solid 1px; 
            }
            .download{
                font-size:1vw;
                margin-top: 2vw;
                color: #0C8E59;
                cursor: pointer;
            }
        }
    }
 }

</style>
